export default "__VITE_ASSET__2ba293f3__"